export const APP_USER_ROLE = "Kabol.User"
export const APP_ADMIN_ROLE = "Kabol.Administrator"
export const APP_SUPER_ADMIN_ROLE = "Kabol.SuperAdmin"
export const TORK_READER_ROLE = "Tork.Reader"
export const TORK_ADMIN_ROLE = "Tork.Admin"
